import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';
import React, {useEffect, useState} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const SelectCellularStage = (props) => {
  const [selectedNum, setNum] = useState(props.subscribersByProduct?.Cellular[0].productSubscriberNo);
  const buttonData = props.subscribersByProduct?.Cellular.map((number, index) => {
    const selected = selectedNum == number.productSubscriberNo ? true : false;
    return {id: index, label: number.productSubscriberNo, value: number.productSubscriberNo, selected: selected};
  });
  return (
    <>
      <div className='headBox'>
        <p className='heading'>
          איזה כיף!
          <br />
          יש לכם כמה מנויי סלולר
        </p>
        <p className='subHeading'>באיזה מנוי תרצו לבצע את הפעולה?</p>
      </div>
      <div className='usersContainer'>
        <SelectOptionButton onClick={setNum} buttonsData={buttonData} />
      </div>
      <div className='finishFooter'>
        <BtnSubmit
          text='המשך'
          onclick={() => {
            props.onclick(selectedNum);
          }}
        />
      </div>
    </>
  );
};

export default SelectCellularStage;
